import '../styles/index.css'

import $ from 'jquery';
import Jconfirm from 'jquery-confirm';
import 'jquery-confirm/css/jquery-confirm.css';
import 'jquery-confirm/dist/jquery-confirm.min.css';

// import stick_in_parent from 'sticky-kit/dist/sticky-kit';

import './OwlCarousel2-master/dist/owl.carousel.min.js'
import './OwlCarousel2-master/dist/assets/owl.carousel.css'
import './OwlCarousel2-master/dist/assets/owl.theme.default.css'

import 'simplebar/dist/simplebar.css';
//
// import SimpleBar from 'simplebar';
import Vote from './vote';
import Currency from './currency';
import BreakingNews from './breakingNews';
// import LoadMore, {isElementExistsInView} from './loadmore';
import Item from './item';
import ItemPublisher from './ItemPublisher';
import {YoutubeSlider} from './Youtube';
import Paginator from './Paginator';
import './weather';

import customScrollbar from './jquery-custom-scrollbar-master/jquery.custom-scrollbar';
import './jquery-custom-scrollbar-master/jquery.custom-scrollbar-rtl.css';


import MediaElementPlayer from 'mediaelement/build/mediaelement-and-player.js';
import 'mediaelement/build/mediaelementplayer.min.css';

import {tabs} from './tabs';
import highlightWord from "./highlightWord";

const dir = "rtl";

((($) => {

    $('body').addClass('with-header-bar')

    tabs('.tabs1');
    // tabs('.tabs2');
    new Vote('.voting');

    new Currency('.currency');
    new BreakingNews('.block-57');
    new BreakingNews('.block-14', {itemSelector: '.latest-items--item'});

    new Item();

    new ItemPublisher();
    /**
     * Send article
     */
    $('.send-article').on('click', function (e) {
        e.preventDefault();
        $.alert({
            title: 'أرسل خبرا أو مقالة',
            theme: 'orient-theme',
            closeIcon: true, // explicitly show the close icon
            draggable: false,
            buttons: false,
            content: function () {
                let self = this;
                return $.ajax({
                    url: '/ajax/item/get-publisher/25',
                    dataType: 'json',
                    method: 'get'
                }).done(function (response) {
                    self.setContent(response.html);
                    let head = document.getElementsByTagName('body')[0];
                    $.each(response.assets.uri, function (type, collection) {
                        $.each(collection, function (urlId, url) {
                            if (!$('document').find('#url-' + urlId).length) {
                                if (type === 'js') {
                                    let script = document.createElement('script');
                                    script.id = 'url-' + urlId;
                                    script.type = 'text/javascript';
                                    script.src = url;
                                    head.appendChild(script);
                                } else if (type === 'css') {
                                    let link = document.createElement('link');
                                    link.id = urlId;
                                    link.rel = 'stylesheet';
                                    link.href = url;
                                    head.appendChild(link);
                                }
                            }
                        });
                    });
                    setTimeout(function () {
                        $.each(response.assets.inline, function (type, collection) {
                            $.each(collection, function (contentId, content) {
                                if (!$('document').find('#inline-' + contentId).length) {
                                    if (type === 'js') {
                                        let script = document.createElement('script');
                                        script.id = 'inline-' + contentId;
                                        script.type = 'text/javascript';
                                        script.innerHTML = content;
                                        head.appendChild(script);
                                    } else if (type === 'css') {
                                        // let link = document.createElement('link');
                                        // link.id = contentId;
                                        // link.rel = 'stylesheet';
                                        // link.href = url;
                                        // head.appendChild(link);
                                    }
                                }

                            });
                        });
                    }, 3000);

                }).fail(function (xhr) {
                    console.log(xhr)
                    self.setContent('Something went wrong.');
                });

            },
            onContentReady: function () {
                let self = this;
                self.$content.find('textarea').val('');
                // this.setContentPrepend('<div>Prepended text</div>');
            },
        });

    });

    new YoutubeSlider('.video-slider');
    new Paginator('[data-paginator]');
    if ($('video').length) {
        $('video').mediaelementplayer({
            // Do not forget to put a final slash (/)
            pluginPath: 'https://cdnjs.com/libraries/mediaelement/',
            // this will allow the CDN to use Flash without restrictions
            // (by default, this is set as `sameDomain`)
            shimScriptAccess: 'always',
            // more configuration
            autoplay: true,
            stretching: 'responsive', /*auto, fill, responsive, none*/
            features: ['playpause', 'duration', 'volume', 'fullscreen'],

        });
    }
    // if ($('audio').length) {
    //     console.log($('audio').length);
    //
    //     $('audio').mediaelementplayer({
    //         // Do not forget to put a final slash (/)
    //         pluginPath: 'https://cdnjs.com/libraries/mediaelement/',
    //         // this will allow the CDN to use Flash without restrictions
    //         // (by default, this is set as `sameDomain`)
    //         shimScriptAccess: 'always',
    //         // more configuration
    //         autoplay: true,
    //         stretching: 'responsive', /*auto, fill, responsive, none*/
    //         // features: ['playpause', 'duration', 'volume', 'fullscreen'],
    //     });
    // }

    if ($('.horoscopes-list').length) {
        let horoscopes = $('.horoscopes-list');
        horoscopes.customScrollbar({
            skin: "default-skin",
            hScroll: false,
            updateOnWindowResize: true,
        });

        horoscopes.on('click', '.head', function () {
            if (horoscopes.find('li.active').length) {
                if ($(this).parents('li').index() !== horoscopes.find('li.active').index()) {
                    horoscopes.find('li.active').find('.details').stop().slideUp('fast', function () {
                        $(this).parents('li').removeClass('active');
                    });
                }
            }
            $(this).parent().find('.details').stop().slideToggle('fast', function () {
                $(this).parents('li').toggleClass('active');
                horoscopes.customScrollbar("resize");
            });

        });
    }
    // if (typeof _home_content_infinite_scroll !== 'undefined') {
    //     if (typeof _pageParams === 'undefined') {
    //         _pageParams = [];
    //     }
    //     new LoadMore('.list-grid-wrapper', _home_content_infinite_scroll, _pageParams);
    // }

    let sidebar = $('#sidebar');
    let logoWrapper = $('.logo');
    let _content = $('#content');
    let mainContent = $('#main-content');
    let mainGrid = $('#main-grid');
    let _breakingNews = $('.block-14');
    let contentSidebar = $('#content-sidebar');

    $('.sidebar__top .b-6 .main-block--head').on('click', function (e) {
        if ($(this).parents('.sidebar__top .b-6').hasClass('is-active')) {
            $(this).parents('.sidebar__top .b-6').removeClass('is-active');
        } else {
            $(this).parents('.sidebar__top .b-6').addClass('is-active');
        }
        e.preventDefault();
        $(this).parents('.block').find('.main-block--content').stop().slideToggle('fast');
    });

    $('.sidebar__top .b-6').hover(function (e) {
        if ($(this).hasClass('is-active')) {
            return;
        }
        $(this).addClass('is-active').find('.main-block--content').stop().slideDown('fast');
    }, function (e) {
        if (!$(this).hasClass('is-active')) {
            return;
        }
        $(this).removeClass('is-active').find('.main-block--content').stop().slideUp('fast');
    });

    $(document).ready(function () {

        highlightWord('شبكة وتر', 'item-content');

        sidebar.css('min-height', $(this).height());
        $('#sidebar .block-1').customScrollbar({
            skin: "default-skin",
            hScroll: false,
            updateOnWindowResize: true,
        });

        mainContent.css('min-height', contentSidebar.height());
        // mainContent.find('>div').css('background-color', $('body').css('background-color'))

        $('#back-to-top').on('click', function () {
            $('html,body').stop().animate({
                scrollTop: 0
            });
        });

        $(window).resize(function () {
            sidebar.css('min-height', $(this).height());
            // $('.header-top-bar').css('width',$(document).width())

        });
        // $('.header-top-bar').css('width',$(document).width())

        const scrollEve = function () {
            const headerTopBar = $('.header-top-bar');
            sidebar.css('min-height', $(window).height());
            let br = 200;
            if (headerTopBar.length) {
                br = headerTopBar.innerHeight();
            }

            if ($(window).scrollTop() >= br) {
                $('#back-to-top').stop().fadeIn('fast');
                if (!sidebar.hasClass('is-scrolling')) {
                    sidebar.addClass('is-scrolling');
                    sidebar.find('.block-1').css('height', sidebar.height() - (sidebar.find('.sidebar__top').height() + sidebar.find('.logo').height() + 40 + (_breakingNews.height() || 0)));
                    logoWrapper.find('.v-logo').stop().slideUp('slow', function () {
                        logoWrapper.find('.h-logo').stop().slideDown('fast');
                    });
                }
            } else {
                $('#back-to-top').stop().fadeOut('fast');
                if (sidebar.hasClass('is-scrolling')) {
                    sidebar.removeClass('is-scrolling');
                    sidebar.find('.block-1').css('height', 'auto');

                    logoWrapper.find('.h-logo').stop().slideUp('fast', function () {
                        logoWrapper.find('.v-logo').stop().slideDown('fast');
                    });
                }
            }
        }
        $(window).scroll(function () {
            scrollEve();
        });

        scrollEve();

        let mainGridWidth = '100%';
        $(window).on('load', function () {
            // mainGridWidth = mainContent.width() + sidebar.width() + contentSidebar.width();
            // mainGrid.css('min-width', mainGridWidth);
        });
        $('#toggle-content-sidebar').on('click', function (e) {
            e.preventDefault();
            $('#column-content-sidebar').stop().fadeToggle('fast');
        });


        const toggleDropDown = (_parent, element) => {
            if (_parent.hasClass('is-active')) {
                $(element).stop().slideUp('fast', function () {
                    $(_parent).removeClass('is-active');
                });
            } else {
                $(element).stop().slideDown('fast', function () {
                    $(_parent).addClass('is-active');
                });
            }
            // $('#sidebar .block-1').customScrollbar("resize");
            setTimeout(function () {
                $(window).trigger('resize');
            }, 500);
        };

        $('.main-menu').on('click', '.has-dropdown>a', function (e) {
            e.preventDefault();
            let _parent = $(this).parents('.has-dropdown');
            let _activeMenus = $(this).parents('.main-menu').find('.has-dropdown.is-active');

            if (_activeMenus.length) {
                $.each(_activeMenus, function (index, element) {
                    if ($(element).attr('id') !== _parent.attr('id')) {
                        toggleDropDown($(element), $(element).find('.dropdown').first());
                    }
                });
                toggleDropDown(_parent, $(this).parent().find('.dropdown').first());
            } else {
                toggleDropDown(_parent, $(this).parent().find('.dropdown').first());
            }
        });

        $('.owl-slider').owlCarousel({
            items: 1,
            autoplay: true,
            nav: true,
            lazyLoad: false,
            dots: false,
            navText: ['<i class="icon-angle-right"></i>', '<i class="icon-angle-left"></i>'],
            rtl: (dir === "rtl"),
            loop: true
        });

        let footerSocialCollapsed = $('.footer-social.collapsed');
        if (footerSocialCollapsed.length) {
            let animateBlock = (el, attr, duration, callback) => {
                if (typeof callback !== 'function') {
                    callback = () => {
                    }
                }
                el.stop().animate(attr, duration, callback);
            };
            let footerSocialBlock = footerSocialCollapsed.find('.block').first();
            footerSocialBlock.attr('data-width', footerSocialCollapsed.width());
            footerSocialBlock.css({
                width: '50px',
                visibility: 'visible',
                borderRadius: '100%',
                opacity: 1,
            }).stop().hide('fast');

            footerSocialCollapsed.hover(function () {
                footerSocialBlock.stop().show('fast', function () {
                    animateBlock(footerSocialBlock, {
                        width: footerSocialBlock.attr('data-width'),
                        // opacity: 1,
                        borderRadius: '50px'
                    }, 150);
                });
            }, function () {
                animateBlock(footerSocialBlock, {
                    width: '50px',
                    // opacity: 0,
                    borderRadius: '50px'
                }, 200, () => {
                    footerSocialBlock.hide('fast');
                });
            });
        }

    });

    /**
     * Floating sidebar
     */


    /**
     * Floating sidebar
     */

    $(window).on('load', function () {

        contentSidebar.css({
            width: contentSidebar.width(),
            height: contentSidebar.height() + 50,
            // position: 'fixed',
        });

        let stickyItemList = $('.sticky-item-list');
        let defaultPageHeader = $('.default-page__header');

        var calculatePosition = function () {
            let position = contentSidebar.height() - $(window).height();

            if (stickyItemList.length) {
                position = position + stickyItemList.height();
            }
            if (defaultPageHeader.length) {
                position = position + defaultPageHeader.height();
            }

            return position;
        };

        let visibleArea = calculatePosition();
        let startBreakPoint = 0;

        if (defaultPageHeader.length) {
            startBreakPoint = contentSidebar.offset().top;
        }

        $(window).on('scroll', function () {
            if ($(this).width() <= 1090) {
                return;
            }

            let position = $(this).scrollTop();
            if ($(this).scrollTop() <= visibleArea) {
                if (position > startBreakPoint) {
                    contentSidebar.css({
                        position: 'fixed',
                    });
                    contentSidebar.css('margin-top', (position * -1));
                } else {
                    contentSidebar.css('margin-top', 0);
                    contentSidebar.css({
                        position: 'relative',
                    });
                }
            } else {
                if (parseInt(contentSidebar.css('margin-top'), 10) < visibleArea) {
                    contentSidebar.css('margin-top', visibleArea * -1);
                } else {
                }
            }
        });

        $(window).resize(function () {
            if ($(this).width() <= 1090) {
                if ($('#column-content-sidebar:visible').length) {

                    $('#column-content-sidebar').stop().fadeOut('fast', function () {
                        if (stickyItemList.length) {
                            contentSidebar.css({
                                'padding-bottom': stickyItemList.height(),
                                'margin-top': 0,
                            })
                        }
                    });
                }
                return;
            }
            if (!$('#column-content-sidebar:visible').length) {
                $('#column-content-sidebar').stop().fadeIn('fast', function () {
                    contentSidebar.css('padding-bottom', 0)
                });
            }
            contentSidebar.width(contentSidebar.parent().width());
        });

    });


})(jQuery));




// WEBPACK FOOTER //
// ./src/scripts/index.js